import React from 'react'
import Modal from 'react-bootstrap/Modal'
import SynkinesisList from './SynkinesisList'
import Button from 'react-bootstrap/Button'

function SynkinesisListModal(props) {

    const onSelect = (synkinesis) => {
        props.onSelect(synkinesis)
    }


    return (
        <Modal dialogClassName="modal-80w" show={props.show} onHide={props.onClose} animation={false} scrollable={true}>
            <Modal.Header closeButton>
                <Modal.Title><h4>Synkinesis Assessments</h4></Modal.Title>
            </Modal.Header>
            <Modal.Body className="mx-4" >
                <SynkinesisList onSelect={onSelect} onUpdateOrDelete={props.onUpdateOrDelete}  updateDeleteCount={props.updateDeleteCount}/>
            </Modal.Body>
            <Modal.Footer className='justify-content-between'>
                <div >
                    <Button className='mx-2' variant="secondary" onClick={props.onClose}>
                        Close
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}

export default SynkinesisListModal
